






































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { QuestelServicesClient } from '@questelservices/common';
import { FileUpload } from '@questelservices/common-vue';
import { FileAuthorizationResult, FileAuthorizationRequest } from '@questelservices/common-vue/dist/models/FileAuthorization';
import { FileDetails } from '@questelservices/common-vue/dist/models/FileDetails';
import CustomStore from 'devextreme/data/custom_store';
import { alert } from 'devextreme/ui/dialog';
import { DxButton } from 'devextreme-vue/button';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { DxColumn, DxDataGrid, DxStateStoring } from 'devextreme-vue/data-grid';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import FileSaver from 'file-saver';
import { AutoTranslationJobDto } from '@/models/auto-translation/AutoTranslationJobDto';
import { AutoTranslationRequestDto } from '@/models/auto-translation/AutoTranslationRequestDto';
import { AutoTranslationService } from '@/service/AutoTranslationService';

interface UploadCompleteResult {
  event: any;
  fileAuthResult: FileAuthorizationResult;
  totalFiles: number;
}

@Component({
  components: {
    DxButton,
    DxCheckBox,
    DxColumn,
    DxDataGrid,
    DxLoadPanel,
    DxStateStoring,
    FileUpload
  }
})
export default class PdfTranslator extends Vue {
  private readonly accept: string = 'application/pdf,application/zip';
  private readonly authUrl: string = '/api/uploads/authorization';
  private readonly combineText: string = 'Combine documents into one file';
  private readonly dataGridRef: string = 'dataGridRef';
  private readonly fileUploaderRef: string = 'fileUploaderRef';
  private readonly includeOriginalsText: string = 'Include original documents';
  private readonly multiple: boolean = true;
  private readonly uploadFailedMessage: string = 'Upload failed';
  private readonly uploadMode: string = 'useButtons';
  private readonly uploadedMessage: string = 'Uploaded';

  private readonly autoTranslationService: AutoTranslationService = new AutoTranslationService();
  private readonly client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');

  private combine: boolean = false;
  private filesToProcess: any[] = [];
  private fileNames: string[] = [];
  private includeOriginals: boolean = false;
  private translationInProgress: boolean = false;

  private get dataGrid() {
    return (this.$refs[this.dataGridRef] as DxDataGrid).instance;
  }

  private get fileUploader() {
    return this.$refs[this.fileUploaderRef] as any;
  }

  private get jobsDataSource() {
    return new CustomStore({
      key: 'JobId',
      load: options => this.autoTranslationService.getJobs(options).catch(this.handleResponseError)
    });
  }

  private downloadFile(fileId?: Guid) {
    if (fileId == null) {
      alert('Unable to download file.', 'Error');
      return;
    }

    let files: FileDetails[] = [{ fileId: fileId }];
    let authorization: FileAuthorizationRequest = {
      files: files
    };

    this.client.getPostData<FileAuthorizationResult>('/api/downloads/authorization', authorization)
      .then(downloadAuthorization => {
        this.client.download(downloadAuthorization.Url, downloadAuthorization.Token)
          .then((downloadResult: Response) => {
            if (downloadResult.ok) {
              let filename: string | undefined = undefined;
              let filenameHeader = downloadResult.headers.get('Filename');

              if (filenameHeader != null) {
                filename = filenameHeader;
              }

              if (filename != null) {
                filename = decodeURIComponent(filename);
              }

              downloadResult.blob().then(data => {
                FileSaver.saveAs(data, filename);
              });
            } else {
              this.handleErrorResponse('An error occurred downloading the translated file(s).');
            }
          })
          .catch(reason => {
            this.handleErrorResponse('An error occurred downloading the translated file(s).');
          });
      })
      .catch(reason => {
        this.handleErrorResponse('An error occurred downloading the translated file(s).');
      });
  }

  private handleResponseError(result: any) {
    let message = 'An unknown error occurred.';
    if (result != null && result.Message != null) {
      message = result.Message;

      let index = message.indexOf(' (Error');
      if (index > -1) {
        message = message.substring(0, index);
      }
    }

    throw Error(message);
  }

  private onFilesReady(event: any) {
    if (event.value != null) {
      this.fileNames = event.value.map((f: any) => f.name);
    } else {
      this.fileNames = [];
    }
  }

  private onUploadComplete(args: UploadCompleteResult) {
    if (args.fileAuthResult.Files.length > 0) {
      this.filesToProcess.push(args.fileAuthResult.Files[0]);
    }

    let progress = args.event.component.option('progress');
    if (progress === 100 && this.filesToProcess.length === args.totalFiles) {
      let files: any[] = [];

      this.fileNames.forEach(fileName => {
        let file = this.filesToProcess.find(f => f.FileName === fileName);
        if (file != null) {
          files.push(file);
        }
      });

      let parameters: AutoTranslationRequestDto = {
        Files: files,
        Combine: this.combine,
        IncludeOriginals: this.includeOriginals
      };

      this.translationInProgress = true;

      this.autoTranslationService.translate(parameters)
        .then(response => {
          if (this.dataGrid != null) {
            this.dataGrid.refresh();
          }

          alert('Documents successfully submitted.', 'Submitted');
          this.reset();
        })
        .catch(reason => {
          this.handleErrorResponse('An error occurred submitting the file(s).');
        })
        .finally(() => {
          this.translationInProgress = false;
        });
    }
  }

  private handleErrorResponse(message: string) {
    alert(message, 'Error');
  }

  private refreshJobs() {
    if (this.dataGrid != null) {
      this.dataGrid.refresh();
    }
  }

  private reset() {
    this.filesToProcess = [];
    this.fileNames = [];
    this.fileUploader.resetUploader();
    this.fileUploader.resetFileUploader();
  }
}
